/** Convert unit, e.g. from cm to mm */
export function convertUnit({ value, conversionRate }) {
  return (value || 0) * conversionRate
}
